// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Robitest Design System — Cloudlight Enterprise (light) + Midnight Control Center (dark) */

:root,
[data-theme="light"] {
  /* Backgrounds */
  --bg-primary: #F7F9FC;
  --bg-secondary: #FFFFFF;
  --bg-tertiary: #F1F5F9;

  /* Surfaces */
  --surface: #FFFFFF;
  --surface-raised: #FFFFFF;
  --surface-hover: #F8FAFC;
  --surface-selected: #EFF6FF;
  --surface-elevated: #FFFFFF;
  --surface-disabled: #F1F5F9;

  /* Borders */
  --border: #E2E8F0;
  --border-subtle: #EDF2F7;
  --border-strong: #CBD5E1;

  /* Inputs */
  --input-background: #FFFFFF;
  --input-border: #E2E8F0;
  --input-placeholder: #94A3B8;

  /* Tables */
  --table-surface: #FFFFFF;
  --table-header: #F1F5F9;
  --table-hover: #F8FAFC;
  --table-border: #E2E8F0;

  /* Primary */
  --primary: #2563EB;
  --primary-hover: #1D4ED8;
  --primary-muted: rgba(37, 99, 235, 0.1);
  --primary-subtle: rgba(37, 99, 235, 0.06);

  /* Accent */
  --accent: #38BDF8;
  --accent-muted: rgba(56, 189, 248, 0.12);

  /* Text */
  --text-primary: #0F172A;
  --text-secondary: #475569;
  --text-muted: #64748B;
  --text-subtle: #94A3B8;
  --text-inverse: #F8FAFC;

  /* Semantic */
  --success: #10B981;
  --success-muted: rgba(16, 185, 129, 0.12);
  --warning: #F59E0B;
  --warning-muted: rgba(245, 158, 11, 0.12);
  --danger: #EF4444;
  --danger-muted: rgba(239, 68, 68, 0.12);
  --info: #3B82F6;
  --info-muted: rgba(59, 130, 246, 0.12);

  /* Shadows */
  --shadow-xs: 0 1px 2px rgba(15, 23, 42, 0.04);
  --shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04);
  --shadow-md: 0 4px 12px rgba(15, 23, 42, 0.06), 0 2px 4px rgba(15, 23, 42, 0.04);
  --shadow-lg: 0 12px 24px rgba(15, 23, 42, 0.08), 0 4px 8px rgba(15, 23, 42, 0.04);
  --shadow-focus: 0 0 0 3px rgba(37, 99, 235, 0.2);

  /* Sidebar / Topbar */
  --sidebar-bg: #FFFFFF;
  --sidebar-background: #FFFFFF;
  --sidebar-border: #E2E8F0;
  --sidebar-width: 240px;
  --sidebar-collapsed-width: 68px;
  --topbar-height: 56px;
  --topbar-bg: rgba(255, 255, 255, 0.92);
  --topbar-background: rgba(255, 255, 255, 0.92);

  /* Tables (extra semantic) */
  --table-row: #FFFFFF;

  /* Charts */
  --chart-grid: #E2E8F0;
  --chart-tick: #94A3B8;
  --chart-tooltip-bg: #0F172A;
  --chart-tooltip-text: #F8FAFC;

  /* Scrollbar — muted gray, always visible */
  --scrollbar-track: transparent;
  --scrollbar-thumb: #94A3B8;
  --scrollbar-thumb-hover: #64748B;

  /* Modal / tooltip / focus */
  --modal-backdrop: rgba(15, 23, 42, 0.55);
  --modal-background: #FFFFFF;
  --modal-shadow: 0 24px 48px rgba(15, 23, 42, 0.18), 0 8px 16px rgba(15, 23, 42, 0.1);
  --tooltip-background: #0F172A;
  --focus-ring: 0 0 0 3px rgba(37, 99, 235, 0.2);

  /* Legacy aliases — keep existing CSS working during migration */
  --primary-color: var(--primary);
  --secondary-color: var(--text-secondary);
  --success-color: var(--success);
  --danger-color: var(--danger);
  --warning-color: var(--warning);
  --info-color: var(--info);
  --light-color: var(--bg-tertiary);
  --dark-color: var(--text-primary);
  --white: #ffffff;
  --black: #000000;
  --bg-light: var(--bg-primary);
  --bg-white: var(--bg-secondary);
  --bg-gray-50: var(--bg-tertiary);
  --bg-gray-100: var(--bg-tertiary);
  --bg-gray-200: var(--border);
  --bg-gradient: none;
  --text-dark: var(--text-primary);
  --text-light: var(--text-inverse);
  --border-color: var(--border);
  --border-light: var(--border-subtle);
  --box-shadow-sm: var(--shadow-sm);
  --box-shadow: var(--shadow-md);
  --box-shadow-md: var(--shadow-md);
  --box-shadow-lg: var(--shadow-lg);
  --box-shadow-xl: var(--shadow-lg);
}

[data-theme="dark"] {
  --bg-primary: #070E1A;
  --bg-secondary: #0A1322;
  --bg-tertiary: #0F1A2C;

  --surface: #0C1626;
  --surface-raised: #0F1B2E;
  --surface-hover: #15233A;
  --surface-selected: #172B47;
  --surface-elevated: #121F33;
  --surface-disabled: #0A1321;

  --border: #1E2D44;
  --border-subtle: #172438;
  --border-strong: #2B3F5C;

  --input-background: #0A1424;
  --input-border: #22334D;
  --input-placeholder: #6B7C93;

  --table-surface: #0C1626;
  --table-header: #0F1B2E;
  --table-hover: #13213A;
  --table-border: #1B2A40;

  --primary: #3B82F6;
  --primary-hover: #60A5FA;
  --primary-muted: rgba(59, 130, 246, 0.16);
  --primary-subtle: rgba(59, 130, 246, 0.1);

  --accent: #38BDF8;
  --accent-muted: rgba(56, 189, 248, 0.16);

  --text-primary: #F1F5F9;
  --text-secondary: #C3CEDC;
  --text-muted: #8898AE;
  --text-subtle: #64748B;
  --text-inverse: #0F172A;

  --success: #22C55E;
  --success-muted: rgba(34, 197, 94, 0.16);
  --warning: #F59E0B;
  --warning-muted: rgba(245, 158, 11, 0.16);
  --danger: #F43F5E;
  --danger-muted: rgba(244, 63, 94, 0.16);
  --info: #3B82F6;
  --info-muted: rgba(59, 130, 246, 0.16);

  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.24);
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(148, 163, 184, 0.03);
  --shadow-md: 0 6px 16px rgba(0, 0, 0, 0.36), 0 0 0 1px rgba(148, 163, 184, 0.04);
  --shadow-lg: 0 16px 36px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(148, 163, 184, 0.05);
  --shadow-focus: 0 0 0 3px rgba(59, 130, 246, 0.35);

  --sidebar-bg: #0A1322;
  --sidebar-background: #0A1322;
  --sidebar-border: #1A283D;
  --topbar-bg: rgba(10, 19, 34, 0.88);
  --topbar-background: rgba(10, 19, 34, 0.88);

  --table-row: #0C1626;

  --chart-grid: #1E2D44;
  --chart-tick: #7F8EA3;
  --chart-tooltip-bg: #1E293B;
  --chart-tooltip-text: #F8FAFC;

  /* Scrollbar — muted blue-gray */
  --scrollbar-track: transparent;
  --scrollbar-thumb: #4A5F78;
  --scrollbar-thumb-hover: #6B8299;

  --modal-backdrop: rgba(2, 6, 16, 0.72);
  --modal-background: #0F1B2E;
  --modal-shadow: 0 24px 48px rgba(0, 0, 0, 0.45), 0 8px 16px rgba(0, 0, 0, 0.3);
  --tooltip-background: #1E293B;
  --focus-ring: 0 0 0 3px rgba(59, 130, 246, 0.35);
}

/* Shared design tokens (theme-agnostic) */
:root {
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 10px;
  --radius-xl: 12px;
  --radius-full: 9999px;

  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 20px;
  --space-6: 24px;
  --space-8: 32px;
  --space-10: 40px;
  --space-12: 48px;

  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-mono: 'JetBrains Mono', 'SF Mono', Consolas, monospace;

  --text-xs: 12px;
  --text-sm: 13px;
  --text-base: 14px;
  --text-md: 15px;
  --text-lg: 16px;
  --text-xl: 18px;
  --text-2xl: 24px;
  --text-3xl: 28px;
  --text-4xl: 32px;

  --font-normal: 400;
  --font-medium: 500;
  --font-semibold: 600;
  --font-bold: 700;

  --transition-fast: 150ms ease;
  --transition-normal: 200ms ease;

  /* Spacing aliases for legacy CSS */
  --spacing-xs: var(--space-1);
  --spacing-sm: var(--space-2);
  --spacing-md: var(--space-4);
  --spacing-lg: var(--space-6);
  --spacing-xl: var(--space-8);
  --spacing-xxl: var(--space-12);

  --font-size-xs: var(--text-xs);
  --font-size-sm: var(--text-sm);
  --font-size-md: var(--text-base);
  --font-size-lg: var(--text-lg);
  --font-size-xl: var(--text-xl);
  --font-size-2xl: var(--text-2xl);
  --font-size-3xl: var(--text-3xl);
  --font-size-4xl: var(--text-4xl);

  --font-weight-light: 300;
  --font-weight-normal: var(--font-normal);
  --font-weight-medium: var(--font-medium);
  --font-weight-semibold: var(--font-semibold);
  --font-weight-bold: var(--font-bold);

  --border-radius-sm: var(--radius-sm);
  --border-radius-md: var(--radius-md);
  --border-radius-lg: var(--radius-lg);
  --border-radius-xl: var(--radius-xl);
  --border-radius-2xl: var(--radius-xl);
  --border-radius-full: var(--radius-full);

  --transition-slow: 300ms ease;

  /* Semantic aliases (design-system vocabulary) */
  --background: var(--bg-primary);
  --background-subtle: var(--bg-tertiary);
  --foreground: var(--text-primary);

  /* Type scale */
  --type-page-title: 24px;
  --type-section-title: 16px;
  --type-body: 14px;
  --type-supporting: 12.5px;
  --leading-tight: 1.25;
  --leading-normal: 1.5;

  /* Motion */
  --ease-out: cubic-bezier(0.22, 1, 0.36, 1);
  --ease-in-out: cubic-bezier(0.65, 0, 0.35, 1);
  --duration-fast: 120ms;
  --duration-normal: 200ms;
  --duration-slow: 320ms;

  /* Layering */
  --z-sticky: 20;
  --z-sidebar: 30;
  --z-topbar: 40;
  --z-dropdown: 1200;
  /* Above fixed navbar (10000); portals/selects sit above modals */
  --z-modal: 12000;
  --z-modal-nested: 13000;
  --z-toast: 14000;
  --z-select-menu: 20000;

  --radius-2xl: 16px;
  --control-height: 36px;
  --control-height-sm: 30px;
}

/* Global theme-aware base */
html {
  color-scheme: light;
}

html[data-theme="dark"] {
  color-scheme: dark;
}

body {
  font-family: var(--font-sans);
  background-color: var(--bg-primary);
  color: var(--text-primary);
  font-size: var(--text-base);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Theme-aware scrollbars */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb-hover);
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
}
`, "",{"version":3,"sources":["webpack://./src/theme/tokens.css"],"names":[],"mappings":"AAAA,4FAA4F;;AAE5F;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;;EAEtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;;EAExB,WAAW;EACX,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;;EAE5B,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;;EAEvB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,uCAAuC;EACvC,yCAAyC;;EAEzC,WAAW;EACX,iBAAiB;EACjB,wCAAwC;;EAExC,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;;EAEvB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,uCAAuC;EACvC,eAAe;EACf,sCAAsC;;EAEtC,YAAY;EACZ,6CAA6C;EAC7C,+EAA+E;EAC/E,gFAAgF;EAChF,iFAAiF;EACjF,gDAAgD;;EAEhD,qBAAqB;EACrB,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,sCAAsC;EACtC,8CAA8C;;EAE9C,4BAA4B;EAC5B,oBAAoB;;EAEpB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;;EAE7B,2CAA2C;EAC3C,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;;EAEhC,4BAA4B;EAC5B,wCAAwC;EACxC,2BAA2B;EAC3B,oFAAoF;EACpF,6BAA6B;EAC7B,8CAA8C;;EAE9C,gEAAgE;EAChE,+BAA+B;EAC/B,wCAAwC;EACxC,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,4BAA4B;EAC5B,mBAAmB;EACnB,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;;EAEtB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;;EAExB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;;EAE5B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;;EAEvB,kBAAkB;EAClB,wBAAwB;EACxB,yCAAyC;EACzC,yCAAyC;;EAEzC,iBAAiB;EACjB,wCAAwC;;EAExC,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;;EAEvB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,uCAAuC;EACvC,eAAe;EACf,sCAAsC;;EAEtC,0CAA0C;EAC1C,8EAA8E;EAC9E,gFAAgF;EAChF,gFAAgF;EAChF,kDAAkD;;EAElD,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,mCAAmC;EACnC,2CAA2C;;EAE3C,oBAAoB;;EAEpB,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;;EAE7B,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;;EAEhC,sCAAsC;EACtC,2BAA2B;EAC3B,8EAA8E;EAC9E,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;;EAErB,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,uFAAuF;EACvF,6DAA6D;;EAE7D,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;;EAEhB,6BAA6B;EAC7B,+BAA+B;;EAE/B,mCAAmC;EACnC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;;EAE9B,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;;EAEhC,wBAAwB;EACxB,wCAAwC;EACxC,wCAAwC;EACxC,4CAA4C;EAC5C,oCAAoC;;EAEpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,wCAAwC;;EAExC,6BAA6B;;EAE7B,gDAAgD;EAChD,+BAA+B;EAC/B,uCAAuC;EACvC,iCAAiC;;EAEjC,eAAe;EACf,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;;EAErB,WAAW;EACX,0CAA0C;EAC1C,6CAA6C;EAC7C,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;;EAEtB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iEAAiE;EACjE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;;EAEtB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,8DAA8D;AAChE","sourcesContent":["/* Robitest Design System — Cloudlight Enterprise (light) + Midnight Control Center (dark) */\n\n:root,\n[data-theme=\"light\"] {\n  /* Backgrounds */\n  --bg-primary: #F7F9FC;\n  --bg-secondary: #FFFFFF;\n  --bg-tertiary: #F1F5F9;\n\n  /* Surfaces */\n  --surface: #FFFFFF;\n  --surface-raised: #FFFFFF;\n  --surface-hover: #F8FAFC;\n  --surface-selected: #EFF6FF;\n  --surface-elevated: #FFFFFF;\n  --surface-disabled: #F1F5F9;\n\n  /* Borders */\n  --border: #E2E8F0;\n  --border-subtle: #EDF2F7;\n  --border-strong: #CBD5E1;\n\n  /* Inputs */\n  --input-background: #FFFFFF;\n  --input-border: #E2E8F0;\n  --input-placeholder: #94A3B8;\n\n  /* Tables */\n  --table-surface: #FFFFFF;\n  --table-header: #F1F5F9;\n  --table-hover: #F8FAFC;\n  --table-border: #E2E8F0;\n\n  /* Primary */\n  --primary: #2563EB;\n  --primary-hover: #1D4ED8;\n  --primary-muted: rgba(37, 99, 235, 0.1);\n  --primary-subtle: rgba(37, 99, 235, 0.06);\n\n  /* Accent */\n  --accent: #38BDF8;\n  --accent-muted: rgba(56, 189, 248, 0.12);\n\n  /* Text */\n  --text-primary: #0F172A;\n  --text-secondary: #475569;\n  --text-muted: #64748B;\n  --text-subtle: #94A3B8;\n  --text-inverse: #F8FAFC;\n\n  /* Semantic */\n  --success: #10B981;\n  --success-muted: rgba(16, 185, 129, 0.12);\n  --warning: #F59E0B;\n  --warning-muted: rgba(245, 158, 11, 0.12);\n  --danger: #EF4444;\n  --danger-muted: rgba(239, 68, 68, 0.12);\n  --info: #3B82F6;\n  --info-muted: rgba(59, 130, 246, 0.12);\n\n  /* Shadows */\n  --shadow-xs: 0 1px 2px rgba(15, 23, 42, 0.04);\n  --shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04);\n  --shadow-md: 0 4px 12px rgba(15, 23, 42, 0.06), 0 2px 4px rgba(15, 23, 42, 0.04);\n  --shadow-lg: 0 12px 24px rgba(15, 23, 42, 0.08), 0 4px 8px rgba(15, 23, 42, 0.04);\n  --shadow-focus: 0 0 0 3px rgba(37, 99, 235, 0.2);\n\n  /* Sidebar / Topbar */\n  --sidebar-bg: #FFFFFF;\n  --sidebar-background: #FFFFFF;\n  --sidebar-border: #E2E8F0;\n  --sidebar-width: 240px;\n  --sidebar-collapsed-width: 68px;\n  --topbar-height: 56px;\n  --topbar-bg: rgba(255, 255, 255, 0.92);\n  --topbar-background: rgba(255, 255, 255, 0.92);\n\n  /* Tables (extra semantic) */\n  --table-row: #FFFFFF;\n\n  /* Charts */\n  --chart-grid: #E2E8F0;\n  --chart-tick: #94A3B8;\n  --chart-tooltip-bg: #0F172A;\n  --chart-tooltip-text: #F8FAFC;\n\n  /* Scrollbar — muted gray, always visible */\n  --scrollbar-track: transparent;\n  --scrollbar-thumb: #94A3B8;\n  --scrollbar-thumb-hover: #64748B;\n\n  /* Modal / tooltip / focus */\n  --modal-backdrop: rgba(15, 23, 42, 0.55);\n  --modal-background: #FFFFFF;\n  --modal-shadow: 0 24px 48px rgba(15, 23, 42, 0.18), 0 8px 16px rgba(15, 23, 42, 0.1);\n  --tooltip-background: #0F172A;\n  --focus-ring: 0 0 0 3px rgba(37, 99, 235, 0.2);\n\n  /* Legacy aliases — keep existing CSS working during migration */\n  --primary-color: var(--primary);\n  --secondary-color: var(--text-secondary);\n  --success-color: var(--success);\n  --danger-color: var(--danger);\n  --warning-color: var(--warning);\n  --info-color: var(--info);\n  --light-color: var(--bg-tertiary);\n  --dark-color: var(--text-primary);\n  --white: #ffffff;\n  --black: #000000;\n  --bg-light: var(--bg-primary);\n  --bg-white: var(--bg-secondary);\n  --bg-gray-50: var(--bg-tertiary);\n  --bg-gray-100: var(--bg-tertiary);\n  --bg-gray-200: var(--border);\n  --bg-gradient: none;\n  --text-dark: var(--text-primary);\n  --text-light: var(--text-inverse);\n  --border-color: var(--border);\n  --border-light: var(--border-subtle);\n  --box-shadow-sm: var(--shadow-sm);\n  --box-shadow: var(--shadow-md);\n  --box-shadow-md: var(--shadow-md);\n  --box-shadow-lg: var(--shadow-lg);\n  --box-shadow-xl: var(--shadow-lg);\n}\n\n[data-theme=\"dark\"] {\n  --bg-primary: #070E1A;\n  --bg-secondary: #0A1322;\n  --bg-tertiary: #0F1A2C;\n\n  --surface: #0C1626;\n  --surface-raised: #0F1B2E;\n  --surface-hover: #15233A;\n  --surface-selected: #172B47;\n  --surface-elevated: #121F33;\n  --surface-disabled: #0A1321;\n\n  --border: #1E2D44;\n  --border-subtle: #172438;\n  --border-strong: #2B3F5C;\n\n  --input-background: #0A1424;\n  --input-border: #22334D;\n  --input-placeholder: #6B7C93;\n\n  --table-surface: #0C1626;\n  --table-header: #0F1B2E;\n  --table-hover: #13213A;\n  --table-border: #1B2A40;\n\n  --primary: #3B82F6;\n  --primary-hover: #60A5FA;\n  --primary-muted: rgba(59, 130, 246, 0.16);\n  --primary-subtle: rgba(59, 130, 246, 0.1);\n\n  --accent: #38BDF8;\n  --accent-muted: rgba(56, 189, 248, 0.16);\n\n  --text-primary: #F1F5F9;\n  --text-secondary: #C3CEDC;\n  --text-muted: #8898AE;\n  --text-subtle: #64748B;\n  --text-inverse: #0F172A;\n\n  --success: #22C55E;\n  --success-muted: rgba(34, 197, 94, 0.16);\n  --warning: #F59E0B;\n  --warning-muted: rgba(245, 158, 11, 0.16);\n  --danger: #F43F5E;\n  --danger-muted: rgba(244, 63, 94, 0.16);\n  --info: #3B82F6;\n  --info-muted: rgba(59, 130, 246, 0.16);\n\n  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.24);\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(148, 163, 184, 0.03);\n  --shadow-md: 0 6px 16px rgba(0, 0, 0, 0.36), 0 0 0 1px rgba(148, 163, 184, 0.04);\n  --shadow-lg: 0 16px 36px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(148, 163, 184, 0.05);\n  --shadow-focus: 0 0 0 3px rgba(59, 130, 246, 0.35);\n\n  --sidebar-bg: #0A1322;\n  --sidebar-background: #0A1322;\n  --sidebar-border: #1A283D;\n  --topbar-bg: rgba(10, 19, 34, 0.88);\n  --topbar-background: rgba(10, 19, 34, 0.88);\n\n  --table-row: #0C1626;\n\n  --chart-grid: #1E2D44;\n  --chart-tick: #7F8EA3;\n  --chart-tooltip-bg: #1E293B;\n  --chart-tooltip-text: #F8FAFC;\n\n  /* Scrollbar — muted blue-gray */\n  --scrollbar-track: transparent;\n  --scrollbar-thumb: #4A5F78;\n  --scrollbar-thumb-hover: #6B8299;\n\n  --modal-backdrop: rgba(2, 6, 16, 0.72);\n  --modal-background: #0F1B2E;\n  --modal-shadow: 0 24px 48px rgba(0, 0, 0, 0.45), 0 8px 16px rgba(0, 0, 0, 0.3);\n  --tooltip-background: #1E293B;\n  --focus-ring: 0 0 0 3px rgba(59, 130, 246, 0.35);\n}\n\n/* Shared design tokens (theme-agnostic) */\n:root {\n  --radius-sm: 6px;\n  --radius-md: 8px;\n  --radius-lg: 10px;\n  --radius-xl: 12px;\n  --radius-full: 9999px;\n\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 12px;\n  --space-4: 16px;\n  --space-5: 20px;\n  --space-6: 24px;\n  --space-8: 32px;\n  --space-10: 40px;\n  --space-12: 48px;\n\n  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-mono: 'JetBrains Mono', 'SF Mono', Consolas, monospace;\n\n  --text-xs: 12px;\n  --text-sm: 13px;\n  --text-base: 14px;\n  --text-md: 15px;\n  --text-lg: 16px;\n  --text-xl: 18px;\n  --text-2xl: 24px;\n  --text-3xl: 28px;\n  --text-4xl: 32px;\n\n  --font-normal: 400;\n  --font-medium: 500;\n  --font-semibold: 600;\n  --font-bold: 700;\n\n  --transition-fast: 150ms ease;\n  --transition-normal: 200ms ease;\n\n  /* Spacing aliases for legacy CSS */\n  --spacing-xs: var(--space-1);\n  --spacing-sm: var(--space-2);\n  --spacing-md: var(--space-4);\n  --spacing-lg: var(--space-6);\n  --spacing-xl: var(--space-8);\n  --spacing-xxl: var(--space-12);\n\n  --font-size-xs: var(--text-xs);\n  --font-size-sm: var(--text-sm);\n  --font-size-md: var(--text-base);\n  --font-size-lg: var(--text-lg);\n  --font-size-xl: var(--text-xl);\n  --font-size-2xl: var(--text-2xl);\n  --font-size-3xl: var(--text-3xl);\n  --font-size-4xl: var(--text-4xl);\n\n  --font-weight-light: 300;\n  --font-weight-normal: var(--font-normal);\n  --font-weight-medium: var(--font-medium);\n  --font-weight-semibold: var(--font-semibold);\n  --font-weight-bold: var(--font-bold);\n\n  --border-radius-sm: var(--radius-sm);\n  --border-radius-md: var(--radius-md);\n  --border-radius-lg: var(--radius-lg);\n  --border-radius-xl: var(--radius-xl);\n  --border-radius-2xl: var(--radius-xl);\n  --border-radius-full: var(--radius-full);\n\n  --transition-slow: 300ms ease;\n\n  /* Semantic aliases (design-system vocabulary) */\n  --background: var(--bg-primary);\n  --background-subtle: var(--bg-tertiary);\n  --foreground: var(--text-primary);\n\n  /* Type scale */\n  --type-page-title: 24px;\n  --type-section-title: 16px;\n  --type-body: 14px;\n  --type-supporting: 12.5px;\n  --leading-tight: 1.25;\n  --leading-normal: 1.5;\n\n  /* Motion */\n  --ease-out: cubic-bezier(0.22, 1, 0.36, 1);\n  --ease-in-out: cubic-bezier(0.65, 0, 0.35, 1);\n  --duration-fast: 120ms;\n  --duration-normal: 200ms;\n  --duration-slow: 320ms;\n\n  /* Layering */\n  --z-sticky: 20;\n  --z-sidebar: 30;\n  --z-topbar: 40;\n  --z-dropdown: 1200;\n  /* Above fixed navbar (10000); portals/selects sit above modals */\n  --z-modal: 12000;\n  --z-modal-nested: 13000;\n  --z-toast: 14000;\n  --z-select-menu: 20000;\n\n  --radius-2xl: 16px;\n  --control-height: 36px;\n  --control-height-sm: 30px;\n}\n\n/* Global theme-aware base */\nhtml {\n  color-scheme: light;\n}\n\nhtml[data-theme=\"dark\"] {\n  color-scheme: dark;\n}\n\nbody {\n  font-family: var(--font-sans);\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: var(--text-base);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Theme-aware scrollbars */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-thumb-hover);\n}\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
